import { Stack } from "@mui/material";
import { FC } from "react";
import { SxProps } from "@mui/system";
import { useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureDiagramUninitializedSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramUninitializedSelector";
import { infrastructureArchitectureDiagramEmptyDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramEmptyDataSelector";
import { infrastructureArchitectureDiagramLoadingSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramLoadingSelector";
import { InfrastructureArchitectureDiagramUninitializedCase } from "@/components/pages/infrastructure-architecture/components/InfrastructureArchitectureDiagramUninitializedCase";
import { InfrastructureArchitectureDiagramLoading } from "@/components/pages/infrastructure-architecture/components/InfrastructureArchitectureDiagramLoading";
import { InfrastructureArchitectureDiagramEmpty } from "@/components/pages/infrastructure-architecture/components/InfrastructureArchitectureDiagramEmpty";

export const InfrastructureArchitectureDiagramSpecialCases: FC = () => {
  const uninitialized = useAppSelector(
    infrastructureArchitectureDiagramUninitializedSelector,
  );
  const diagramDataEmpty = useAppSelector(
    infrastructureArchitectureDiagramEmptyDataSelector,
  );
  const diagramLoading = useAppSelector(
    infrastructureArchitectureDiagramLoadingSelector,
  );

  return (
    <Stack spacing={4} sx={stackStyles}>
      {uninitialized && <InfrastructureArchitectureDiagramUninitializedCase />}

      {diagramDataEmpty && <InfrastructureArchitectureDiagramEmpty />}

      {diagramLoading && <InfrastructureArchitectureDiagramLoading />}
    </Stack>
  );
};

const stackStyles: SxProps = {
  width: "100%",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
};
